import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import {URI} from '../../Conexiones/Conexion';
import { getToken } from '../../Conexiones/Conexion';

const ResumenOfi = () => {
    const navigate = useNavigate()
    const [totalPago, setTotalPago] = useState(0)
    const [totalOficina, setTotalOficina] = useState(0)

    useEffect(() => {
        const getTotalPago = async () => {
            const res = await axios.get(URI+'getTotalPagosOficina',{
                headers: {
                    'Authorization': `Bearer ${getToken()}`
                },
                }).catch(
                    err =>{
                        if(err.response.data === "Token Inválido" | err.response.data === "Token requerido"){
                            navigate('/')
                        }
                    }
                )
            setTotalPago(res.data[0].total);
        }
        getTotalPago();
    }, [navigate]);

    useEffect(() => {
        const getTotalOf = async () => {
            const res = await axios.get(URI+'getOficinaTotal',{
                headers: {
                    'Authorization': `Bearer ${getToken()}`
                },
                }).catch(
                    err =>{
                        if(err.response.data === "Token Inválido" | err.response.data === "Token requerido"){
                            navigate('/')
                        }
                    }
                )
            setTotalOficina(res.data[0].total);
        }
        getTotalOf();
    }, [navigate]);

    const totalFinal = totalPago + totalOficina;

    function formato(numero){
        var num = Number.parseFloat(numero).toFixed(2)
        return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',');
    }
    
    const pagoTotal = formato(totalPago)
    const totalOfi= formato(totalOficina)
    const total= formato(totalFinal)

    return (
        <div>            
        <div className="modal fade" id="modal-resumen-oficina" data-bs-backdrop="static"  tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
            <div className="modal-dialog ">
                <div className="modal-content">
                    <div className="modal-header btncolor" >
                        <h5 className="modal-title" id="exampleModalLabel">RESUMEN DE GASTOS DE OFICINA</h5>
                        <button type="button" className="btn-close bg-white" data-bs-dismiss="modal" aria-label="Close" ></button>
                    </div>
                    <div className="modal-body" style={{textAlign:'right'}}>
                        
                        <div className="row">
                            <div className="col">
                                <label htmlFor="exampleFormControlInput1" className="form-label">PAGO OFICINA</label>
                            </div>
                            <div className="col">
                                <label htmlFor="exampleFormControlInput1" className="form-label">
                                    <strong>
                                        $ {pagoTotal === 'NaN' ? (0):(pagoTotal)}
                                    </strong>
                                </label>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col">
                                <label htmlFor="exampleFormControlInput1" className="form-label">OFICINA</label>
                            </div>
                            <div className="col">
                                <label htmlFor="exampleFormControlInput1" className="form-label">
                                    <strong>
                                        $ {totalOfi === 'NaN' ? (0):(totalOfi)}
                                    </strong>
                                </label>
                            </div>
                        </div>
                        <hr/>
                        <div className="row">
                            <div className="col" >
                                <label htmlFor="exampleFormControlInput1" className="form-label">TOTAL</label>
                            </div>
                            <div className="col">
                                <label htmlFor="exampleFormControlInput1" className="form-label">
                                    <strong>
                                        $ {total === 'NaN' ? (0):(total)}
                                    </strong>
                                </label>
                            </div>
                        </div>     
                    </div>
                    <div className="modal-footer justify-content-center">
                        <button type="button" className="btn btncolor" data-bs-dismiss="modal">ACEPTAR</button>                                                
                    </div>
                </div>
            </div>
        </div>
    </div>
    );
};

export default ResumenOfi;